import { network } from 'services/network';

export const getTemplateNames = () => {
    const url = `api/bo/phaseperformance/getTemplateNames`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
